import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { medicationSchema } from "../Validations/MedicamentValidation";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import "../Ajouter_medicament/ajouter.css";
import { useParams } from "react-router-dom";
import { HospitalInterface } from "../interfaces";
import CircularProgress from "@mui/material/CircularProgress";
import { rootUrl } from "../constants";
import { CurrentUserContext } from "../App";
import { FaRegBell } from "react-icons/fa";
import { MdLogout } from "react-icons/md";

const AjouterHospital = () => {
  const [error, setError] = useState(null);
  const { id: hospitalId } = useParams();
  const [hospitalData, setHospitalData] = useState<HospitalInterface | null>(
    null
  );
  const navigate = useNavigate();

  let currentSelectedHospitalId =
    useContext(CurrentUserContext).currentUserData!.selectedHospitalId;

  const hospitalSchema = yup.object().shape({
    name: yup.string().required("Veuillez saisir le nom du centre "),
    addresse: yup.string().required("Veuillez saisir l'addresse du centre "),
    username: yup.string().required("Veuillez saisir l'identifiant "),

    password: yup.string().required("Veuillez saisir le mot de passe"),
  });

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  let token = useContext(CurrentUserContext).currentUserData!.token;
  let setCurrentUser = useContext(CurrentUserContext).setCurrentUser;
  useEffect(() => {
    if (hospitalId) {
      axios
        .get(rootUrl + "/hospital/" + hospitalId, {
          headers: {
            Authorization: "Token " + token,
          },
        })
        .then((response: { data: any }) => {
          console.log("data returned : ");
          console.log(response);
          setHospitalData(response.data);
        })
        .catch((error: any) => {
          navigate("/admin/hospitals");
        });
    }
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(hospitalSchema),
  });

  const submitForm = (data: any) => {
    const newHospital = {
      name: data.name,
      addresse: data.addresse,
      username: data.username,
      password: data.password,
    };

    if (hospitalId) {
      axios
        .put(
          rootUrl + "/hospital/" + hospitalId,

          newHospital,
          {
            headers: {
              Authorization: "Token " + token,
            },
          }
        )
        .then((response) => {
          navigate("/admin/hospitals");
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setIsSubmitting(true);
      axios
        .post(rootUrl + "/hospital/" + hospitalId + "/inventory", newHospital, {
          headers: {
            Authorization: "Token " + token,
          },
        })
        .then((response) => {
          navigate("/admins/hospitals");
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  return (
    <div className="ajouter-wrapper">
      <h1 className="title">
        {!hospitalId ? "Ajouter un centre" : "Mettre à jour"}
      </h1>
      <div className="positioned-buttons">
        <button className="notif-button">
          <FaRegBell />
        </button>
        <button className="logout-button">
          <MdLogout />
        </button>
      </div>
      {hospitalId && !hospitalData ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress thickness={6} sx={{ color: "#0B63F8" }} />
        </div>
      ) : (
        <form onSubmit={handleSubmit(submitForm)}>
          <div className="row">
            <div className="column-side">
              <div className="input-grp">
                <label className="label" htmlFor="name">
                  Le nom du centre
                </label>
                <div className="input-p">
                  <input
                    className="input-1"
                    defaultValue={hospitalData?.name ?? ""}
                    {...register("name")}
                    type="text"
                    name="name"
                  />
                  <p className="error-msg">{errors.name?.message}</p>
                </div>
              </div>

              <div className="input-grp">
                <label className="label" htmlFor="addresse">
                  Adresse du centre
                </label>
                <div className="input-p">
                  <input
                    className="input-1"
                    type="number"
                    defaultValue={hospitalData?.addresse ?? ""}
                    {...register("addresse")}
                    name="addresse"
                  />
                  <p className="error-msg">{errors.addresse?.message}</p>
                </div>
              </div>
            </div>

            <div className="column-side">
              <div className="input-grp">
                <label className="label" htmlFor="username">
                  Entrez l'identifiant
                </label>

                <div className="input-p">
                  <input
                    className="input-1"
                    type="text"
                    // defaultValue={hospitalData?.username ?? ""}
                    {...register("username")}
                    name="username"
                  />
                  <p className="error-msg">{errors.username?.message}</p>
                </div>
              </div>

              <div className="input-grp">
                <label className="label" htmlFor="password">
                  Entrez le mot-de-passe
                </label>
                <div className="input-p">
                  <input
                    className="input-1"
                    type="text"
                    // defaultValue={hospitalData?.password ?? ""}
                    {...register("password")}
                    name="password"
                  />
                  <p className="error-msg">{errors.password?.message}</p>
                </div>
              </div>
            </div>
          </div>

          <input
            className="ajouter-button"
            disabled={isSubmitting}
            type="submit"
            value={hospitalId ? "Modifier" : "Ajouter"}
          />
        </form>
      )}
    </div>
  );
};

export default AjouterHospital;
